/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {chooseBar} from '../../common/bars/actions';
import {fetchBranches} from '../../common/branches/actions';
import {logout} from '../../common/login/actions';
import {fromJS} from 'immutable';

class ChooseBar extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        chooseBar: React.PropTypes.func,
        logout: React.PropTypes.func,
        fetchBranches: React.PropTypes.func,
        branches: React.PropTypes.object,
        noBranches: React.PropTypes.bool,
        deviceId: React.PropTypes.number
    };

    componentWillMount() {
        const {fetchBranches, chooseBar} = this.props;
        fetchBranches().payload.promise
            .then(res => {
                if (!!res.data && res.data.length === 1 && res.data[0].bars.length === 1) {
                    const branch = fromJS(res.data[0]);
                    chooseBar(branch.get('bars').first(), branch);
                }
            })
            .catch(() => console.error('ChooseBarError'));
    }

    render() {
        const {chooseBar, branches, noBranches, logout, deviceId, msg} = this.props;

        return (
            <div id="login-page" className="pageNotification">
                <h1 className="pageNotification-logo">{msg.global.appName}</h1>

                {!!noBranches &&
                    <div className="pageNotification-content">
                      <h2 className="pageNotification-title">{msg.chooseBar.noBranch.title}</h2>
                        <div className="pageNotification-row">
                            {msg.chooseBar.noBranch.text}
                        </div>
                        <div className="pageNotification-row">
                            <button className="btn btn-block btn-red" onClick={() => logout(deviceId)}>
                                {msg.global.logout}
                            </button>
                        </div>
                    </div>
                }

                {!noBranches &&
                    <div className="pageNotification-content">
                        <h2 className="pageNotification-title">{msg.chooseBar.selectBranch.title}</h2>
                            {!!branches && branches.map(branch =>
                                <div className="pageNotification-box" key={`branch-${branch.get('id')}`}>
                                    <h3 className="pageNotification-box-title">{branch.get('name')}</h3>
                                    {branch.get('bars').map(bar =>
                                      <div className="pageNotification-box-row" key={`bar-${bar.get('id')}`}>
                                        <div className="btn btn-greenLight btn-block"
                                             onClick={() => chooseBar(bar, branch)}
                                             key={`bar-${bar.get('id')}`}>
                                                {bar.get('name')}
                                        </div>
                                      </div>
                                    )}
                                </div>
                            )}
                    </div>
                }
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    branches: state.branches.get('branches'),
    noBranches: state.branches.get('noBranches'),
    deviceId: state.device.get('id')
}), {chooseBar, fetchBranches, logout})(ChooseBar);



// WEBPACK FOOTER //
// ./src/browser/login/ChooseBar.js